import React from 'react';
import './FarmingCalculatorPage.css';
import GoldCalculatorAdvanced from '../StaticSandbox/components/GoldCalculatorAdvanced';

// Mock scenario for the farming calculator
const mockScenario = {
  id: 'farming-analysis',
  name: 'Farming Analysis',
  description: 'Comprehensive farming and gold analysis tool',
  purchaseTimeline: [],
  goldRules: {
    startingGold: 500,
    goldPerLevel: 0,
    averageCSPerMinute: 10,
    estimatedKills: 0
  }
};

const FarmingCalculatorPage: React.FC = () => {
  return (
    <div className="farming-calculator-page">
      <div className="page-header">
        <h1>Gold Calculator</h1>
        <p>Comprehensive analysis of CS performance, gold income, and XP progression</p>
      </div>
      
      <div className="farming-calculator-content">
        <GoldCalculatorAdvanced scenario={mockScenario} />
      </div>
    </div>
  );
};

export default FarmingCalculatorPage;
